import { Component, computed, input } from '@angular/core';
import { RealEstateLinkPipe } from '@web/shared/pipes/real-estate-link.pipe';
import { isEmpty } from 'class-validator';
import { RealEstateCodeTagComponent } from '../../real-estate-code-tag.component';
import { SearchRealEstateEntry } from '../interfaces/search-real-estate-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';

@Component({
  selector: 'app-search-real-estate-item',
  imports: [RealEstateCodeTagComponent, RealEstateLinkPipe, SearchItemBaseComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-building"
      color="text-soe-orange-glow"
      [detailRouterLink]="_item | realEstateLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-real-estate-code-tag [realEstate]="_item" [clickable]="false" />
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchRealEstateItemComponent {
  readonly item = input.required<SearchRealEstateEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-map-marker',
        content: `${item.address} ${item.streetNumber}, ${item.zipCode} ${item.city}, ${item.state}, ${item.country}`,
        isHtml: true,
      },
      {
        icon: 'pi pi-tag',
        content: item.typology,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
